import React from 'react';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row
} from 'reactstrap';
import logoLight from "../../assets/images/logo-light.png";
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from "reselect";
import withRouter from 'components/Common/withRouter';

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

const ForgetPasswordPage = props => {
  document.title = "Reset Password | My Urban Farms";

  const dispatch = useDispatch();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
      confirmPassword: ''
    },

    validationSchema: Yup.object({
      email: Yup.string().required("Please enter your email"),
      password: Yup.string().required("Please enter new password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords do not match")
        .required("Please confirm password"),
    }),

    onSubmit: (values) => {
      dispatch(
        userForgetPassword(
          {
            email: values.email,
            password: values.password
          },
          props.router.navigate
        )
      );
    }
  });

  /** Redux Selector */
  const selectForgotPasswordState = (state) => state.ForgetPassword;

  const ForgotPasswordProperties = createSelector(
    selectForgotPasswordState,
    (forgetPassword) => ({
      forgetError: forgetPassword.forgetError,
      forgetSuccessMsg: forgetPassword.forgetSuccessMsg,
    })
  );

  const { forgetError, forgetSuccessMsg } = useSelector(ForgotPasswordProperties);

  return (
    <React.Fragment>
      <style>{`


       
        @keyframes floatOrb {
          0%, 100% { 
            transform: translate(0, 0) scale(1);
            opacity: 0.6;
          }
          33% { 
            transform: translate(30px, -30px) scale(1.1);
            opacity: 0.4;
          }
          66% { 
            transform: translate(-20px, 20px) scale(0.95);
            opacity: 0.5;
          }
        }



        .glassmorphic-card {
          backdrop-filter: blur(30px) saturate(180%);
          background: rgba(255, 255, 255, 0.15) !important;
          border: 2px solid rgba(255, 255, 255, 0.25) !important;
          border-radius: 28px !important;
          box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.3),
                      0 0 0 1px rgba(255, 255, 255, 0.1) inset !important;
          overflow: visible !important;
          position: relative;
        }


    

  



        .forgot-subtitle {
          text-align: center;
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          margin-bottom: 2rem;
          font-weight: 500;
        }



        




        .glassmorphic-input::placeholder {
          color: rgba(255, 255, 255, 0.55) !important;
        }

        .glassmorphic-input:focus {
          background: rgba(255, 255, 255, 0.18) !important;
          border-color: rgba(255, 255, 255, 0.5) !important;
          box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1),
                      0 6px 20px rgba(0, 0, 0, 0.12) !important;
          color: white !important;
          transform: translateY(-1px);
        }

        .glassmorphic-input.is-invalid {
          border-color: #ff6b6b !important;
          box-shadow: 0 0 0 3px rgba(255, 107, 107, 0.2) !important;
        }

   


        .glassmorphic-btn:active {
          transform: translateY(0);
          box-shadow: 0 4px 12px rgba(91, 116, 99, 0.4);
        }

        .signin-text {
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          margin-top: 1.75rem;
          font-weight: 500;
        }

        .signin-link {
          color: white;
          font-weight: 700;
          text-decoration: none;
          padding: 4px 8px;
          border-radius: 6px;
          transition: all 0.3s ease;
        }

        .signin-link:hover {
          background: rgba(255, 255, 255, 0.15);
          text-decoration: none;
          color: white;
        }

        .decorative-circle-1 {
          position: absolute;
          bottom: -30px;
          left: -30px;
          width: 120px;
          height: 120px;
          background: radial-gradient(circle, rgba(210, 221, 213, 0.4), transparent);
          border-radius: 50%;
          filter: blur(40px);
        }

        .decorative-circle-2 {
          position: absolute;
          top: -30px;
          right: -30px;
          width: 150px;
          height: 150px;
          background: radial-gradient(circle, rgba(122, 143, 126, 0.5), transparent);
          border-radius: 50%;
          filter: blur(45px);
        }



   

        .alert-success-glass {
          background: rgba(34, 197, 94, 0.25) !important;
          border: 1.5px solid rgba(34, 197, 94, 0.4) !important;
          color: white !important;
          border-radius: 14px !important;
          backdrop-filter: blur(10px);
          box-shadow: 0 4px 12px rgba(34, 197, 94, 0.2);
          font-weight: 500;
          margin-bottom: 1.5rem;
        }

        /* Subtle shimmer effect on card */
        @keyframes shimmer {
          0% { background-position: -1000px 0; }
          100% { background-position: 1000px 0; }
        }

        .glassmorphic-card::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.03), transparent);
          background-size: 1000px 100%;
          animation: shimmer 6s infinite;
          border-radius: 28px;
          pointer-events: none;
        }

        .info-box {
          background: rgba(91, 116, 99, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          padding: 1rem;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(10px);
        }

        .info-icon {
          color: rgba(255, 255, 255, 0.9);
          font-size: 18px;
          margin-right: 8px;
        }

        .info-text {
          color: rgba(255, 255, 255, 0.85);
          font-size: 13px;
          line-height: 1.6;
          margin: 0;
        }
      `}</style>

      <div className="glassmorphic-forgot-page" style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #8fa88f 0%, #a8b9ad 25%, #7a8f7e 50%, #6b7d6f 75%, #5b7463 100%)',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        padding: '2rem 0'
      }}>
        {/* Glowing orbs */}
        <div className="glowing-orb-1"></div>
        <div className="glowing-orb-2"></div>
        <div className="glowing-orb-3"></div>

        {/* Landscape silhouettes */}
        {/* <svg className="landscape-svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="#4a6152" 
            fillOpacity="0.35" 
            d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
        <svg className="landscape-svg" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="#5b7463" 
            fillOpacity="0.55" 
            d="M0,160L48,170.7C96,181,192,203,288,208C384,213,480,203,576,170.7C672,139,768,85,864,80C960,75,1056,117,1152,138.7C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg> */}

        <Container style={{ position: 'relative', zIndex: 4 }}>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5} style={{ position: 'relative', zIndex: 10 }}>

              <Card className="glassmorphic-card">
                <CardBody>
                  <div className="logo-container">
                    <img src={logoLight} width={100} alt="Logo" />
                  </div>
                  <h1 className="forgot-title">Reset Password</h1>
                  <div className="title-underline"></div>
                  <p className="forgot-subtitle">Enter your email to reset your password</p>

                  {forgetError && forgetError ? (
                    <Alert className="alert-glass">
                      {forgetError}
                    </Alert>
                  ) : null}

                  {forgetSuccessMsg ? (
                    <Alert className="alert-success-glass">
                      {forgetSuccessMsg}
                    </Alert>
                  ) : null}

  
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                    }}
                  >
                    {/* Email */}
                    <div className="mb-3">
                      <Label className="text-white">Email</Label>
                      <Input
                        name="email"
                        type="email"
                        placeholder="Enter email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email}
                        invalid={
                          validation.touched.email &&
                          validation.errors.email
                        }
                      />
                      <FormFeedback>{validation.errors.email}</FormFeedback>
                    </div>

                    {/* New Password */}
                    <div className="mb-3">
                      <Label className="text-white">New Password</Label>
                      <Input
                        name="password"
                        type="password"
                        placeholder="Enter new password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password
                        }
                      />
                      <FormFeedback>{validation.errors.password}</FormFeedback>
                    </div>

                    {/* Confirm Password */}
                    <div className="mb-3">
                      <Label className="text-white">Confirm Password</Label>
                      <Input
                        name="confirmPassword"
                        type="password"
                        placeholder="Confirm password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.confirmPassword}
                        invalid={
                          validation.touched.confirmPassword &&
                          validation.errors.confirmPassword
                        }
                      />
                      <FormFeedback>
                        {validation.errors.confirmPassword}
                      </FormFeedback>
                    </div>

                    <button className="btn glassmorphic-btn" type="submit">
                      Reset Password
                    </button>

                    <div className="signin-text">
                      Remember It?{' '}
                      <Link to="/login" className="signin-link">
                        Sign In Here
                      </Link>
                    </div>
                  </form>
                </CardBody>
              </Card>

              {/* Decorative circles */}
              <div className="decorative-circle-1"></div>
              <div className="decorative-circle-2"></div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);